export default __webpack_public_path__ + "static/media/3-pieces-middle-mantle.43427d06.svg";